﻿import './sections.css'
import { useBookDemo } from './BookDemoContext'
export default function CTASection() {
  const openBookDemo = useBookDemo()
  return (
    <section className="cta-section">
      <div className="container" style={{ textAlign: 'center' }}>
        <p className="section-eyebrow" style={{ color: 'var(--accent-light)' }}>TRANSFORM YOUR WORKFORCE TODAY</p>
        <h2 className="section-title">The Enterprise AI Platform Your Talent Team Has Been Waiting For</h2>
        <p className="section-subtitle">Join enterprise leaders who trust PossoBuild to transform hiring, development, and workforce performance — at scale.</p>
        <div className="cta-columns">
          <div className="cta-column">
            <h3>Book a Demo</h3>
            <ul className="cta-list">
              <li>✓ Live 45-minute platform walkthrough</li>
              <li>✓ Custom ROI analysis for your organization</li>
              <li>✓ See SmartHire live with your job descriptions</li>
              <li>✓ Implementation timeline and resources</li>
            </ul>
            <button className="btn-primary btn-large" onClick={() => openBookDemo('Book an Enterprise Demo')}>Book an Enterprise Demo →</button>
          </div>
          <div className="cta-column">
            <h3>Start a Pilot</h3>
            <ul className="cta-list">
              <li>✓ 90-day paid pilot with full support</li>
              <li>✓ Deploy one product, any team, any size</li>
              <li>✓ Dedicated customer success manager</li>
              <li>✓ Proven results before full commitment</li>
            </ul>
            <button className="btn-secondary btn-large" onClick={() => openBookDemo('Start Your Pilot')}>Start Your Pilot →</button>
          </div>
        </div>
      </div>
    </section>
  )
}
